// Six side-by-side integer inputs for quantity breaks.
// 0 (or empty) means "slot unused" — pricing engine will skip.

export default function QuoteBreakInputs({ value, onChange, disabled }) {
  // value is an array of 6 (numbers or strings/empty). Pad to length 6 just in case.
  const padded = [...(value || []), 0, 0, 0, 0, 0, 0].slice(0, 6);

  return (
    <div className="grid grid-cols-6 gap-2">
      {padded.map((q, idx) => (
        <div key={idx}>
          <label className="block text-xs font-medium text-slate-600 mb-1">
            Break {idx + 1}
          </label>
          <input
            type="number"
            min="0"
            step="1"
            value={q === 0 || q === '0' ? '' : q ?? ''}
            onChange={(e) => onChange(idx, e.target.value)}
            disabled={disabled}
            placeholder="—"
            className="w-full px-2 py-1.5 text-sm border border-slate-200 rounded-sm text-right tabular-nums focus:outline-none focus:ring-1 focus:ring-slate-400 disabled:bg-slate-50 disabled:text-slate-500"
          />
        </div>
      ))}
    </div>
  );
}
